// extracted by mini-css-extract-plugin
export var container = "_96-0";
export var fallback = "_96-5";
export var fallbackIcon = "_96-6";
export var hidden = "_96-2";
export var image = "_96-3";
export var loaded = "_96-4";
export var placeholder = "_96-1";